import StockPostRetailCashSales from "../../../../components/@documents/retail_cash_sales/StockPostRetailCashSales";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function RetailCashSalesStockPostPage() {

    return (
        <StockPostRetailCashSales 
            routeType={routeTypes.admin}
        />
    )
}